import PlanReview from 'features/payLater/screens/PlanReview/PlanReview';

export default function Page() {
  return <PlanReview />;
}
